const hasColoredIcon = (ele) => {
  var _a, _b;
  if (!ele)
    return false;
  return (_b = (_a = ele == null ? void 0 : ele.type) == null ? void 0 : _a.name) == null ? void 0 : _b.endsWith("Colored");
};

export { hasColoredIcon };
